class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.endTime = new Date(this.dataset.endTime).getTime();
    this.daysEl = this.querySelector("[data-days]");
    this.hoursEl = this.querySelector("[data-hours]");
    this.minsEl = this.querySelector("[data-mins]");
    this.secsEl = this.querySelector("[data-secs]");

    if (isNaN(this.endTime)) return;

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      clearInterval(this.interval);
      this.setValues(0, 0, 0, 0);
      this.dispatchEvent(new CustomEvent("countdown:complete", { bubbles: true }));
      return;
    }

    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    const mins = Math.floor((remaining % 3600000) / 60000);
    const secs = Math.floor((remaining % 60000) / 1000);

    this.setValues(days, hours, mins, secs);
  }

  setValues(days, hours, mins, secs) {
    const pad = (value) => String(value).padStart(2, "0");
    if (this.daysEl) this.daysEl.textContent = pad(days);
    if (this.hoursEl) this.hoursEl.textContent = pad(hours);
    if (this.minsEl) this.minsEl.textContent = pad(mins);
    if (this.secsEl) this.secsEl.textContent = pad(secs);
  }
}

class QuantityStepper extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector("[data-quantity-input]");
    this.minusButton = this.querySelector("[data-quantity-minus]");
    this.plusButton = this.querySelector("[data-quantity-plus]");

    this.minusButton?.addEventListener("click", () => this.step(-1));
    this.plusButton?.addEventListener("click", () => this.step(1));
  }

  step(delta) {
    if (!this.input) return;
    const min = parseInt(this.input.min, 10) || 1;
    const current = parseInt(this.input.value, 10) || min;
    const next = Math.max(min, current + delta);
    this.input.value = next;
    this.input.dispatchEvent(new Event("change", { bubbles: true }));
  }
}

customElements.define("countdown-timer", CountdownTimer);
customElements.define("quantity-stepper", QuantityStepper);
